import { HANDLE_MODALS, HANDLE_MODALS_DATA } from '../actionTypes';

const initialState = {
    modals: {
        "CREATE_WATCHLIST_MODAL": false,
        "GLOBAL_WATCHLIST_SCRIPT_MODAL": false,
        "GLOBAL_SEARCH_OPTION_MODAL": false,
        "SCRIPT_RECOMMENDATIONS_MODAL": false,
        "ADD_SCRIPT_ACTIVE_MODAL": false,
        "CHOOSE_WATCHLIST_MODAL": false,
        "GRID_MANAGE_COLUMN_MODAL": false,
        "RENAME_MODAL": false,
        'EDIS_AUTHENTICATION_MODAL': false,
        'RETRIVE_USERID_MODAL': false,
        'FUNDS_BREAKUP_MODAL': false,
        'USER_MARGINAL_MODAL': false,
        'TERMS_CONDITION_MODAL': false,
        'ABOUT_US_MODAL': false,
        'DISCLAIMER_MODAL': false,
        'EXCHANGE_TIMING_MODAL': false,
        'REGISTRATION_MODAL': false,
        'ORDER_ENTRY': false,
        'ORDER_ENTRY_SIDETRAY_CONFIRMATION': false,
        'WATCHLIST_SHARE_MODAL': false,
        'OPTION_CHAIN': false,
        //IPO Modals
        'IPO_DETAILS_MODAL': false,
        'BID_DETAILS_MODAL': false,
        'IPO_PLACEBID_MODAL': false,
        'SUBCRIPTION_MODAL': false,
        'VIEW_PLACEBID_ORDER_MODAL': false,
        'BID_MODIFY_MODAL': false,
        'CANCEL_BID_MODAL': false,
        'CONFIRM_CANCEL_MODAL': false,
        'CONFIRM_CANCEL_MESSAGE_MODAL': false,
        'CONFIRM_PAY_MODAL': false,
        'WATCHLIST_MANAGE_COLUMNS_MODAL': false,
        'WATCHLIST_CONFIRMATION_MODAL': false,
        'ORDER_CONFIRMATION_MODAL': false,
        'ORDER_DETAILS_MODAL': false,
        'WATCHLIST_NAMING_MODAL': false,
        'IPO_TERMS_CONDITION_MODAL': false,
        //MF
        'NFO_DETAILS': false,
        'PLACE_NFO_ORDER': false,
        'CONFIRM_BUY_ORDER': false,
        'ORDER_PLACE_SUCCEFULL': false,
        'PLACE_MUTUAL_FUND_ORDER': false,
        'CREATE_WATCHLIST': false,
        'CHOOSE_WATCHLIST': false,
        'CREATE_CUSTOM_WATCHLIST': false,
        'ADD_WATCHLIST': false,
        'FILTER_MODAL': false,
        'RENAME_WATCHLIST': false,
        'DELETE_WATCHLIST': false,
        'ADD_FUND_MODAL': false,
        'MARKET_OVERVIEW_MODAL': false,
        'SQUARE_OFF_MODAL': false,
        'GLOBAL_SEARCH_ADDSCRIP_MODAL': false,
        'GLOBAL_SEARCH_REMOVE_EXTRASCRIPS_MODAL': false,

        // funds
        'FUNDS_MODAL': false,
        "TRANSACTION_MODAL": false,
        "TRANSACTION_FILTER_MODAL": false,
        "MANDATE_REPORT_MODAL": false,
        "MANDATE_DETAILS_MODAL": false,
        'ADD_FUNDS_MODAL': false,
        'WITHDRAW_MODAL': false,
        'TRANSFER_MODAL': false,
        'SUCCESS_MODAL': false,
        'MANDATE_REGISTER_MODAL': false,
        "BANK_AVAILABLE_MODAL": false,
        "TRANSACTION_DETAILS_MODAL": false,
        "TRANSACTION_CANCEL_CONFIRMATION_MODAL": false,

        //    order entry
        'ORDER_ENTRY_MODAL': false,
        'ORDER_ENTRY_CONFIRMATION': false,
        'ORDER_STATUS': false,
        'BROKERAGE_CHARGES_MODAL': false,
        'RATE_US_AND_FEEDBACK_MODAL': false,
        'ORDER_CART_NAME_MODAL': false,
        'SAVE_CART_CONFIRM_MODAL': false,
        "EXPIRED_SCRIP_ALERT_MODAL": false,
        'BANNED_SCRIP_MODAL': false,
        'SURV_MEASURE': false,
        'MODIFY_ORDER_MODAL': false,
        'CANCEL_ORDER_MODAL': false,
        'EXIT_OR_CONVERT_POSITION_ORDER_MODAL': false,//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order
        'RE_ORDER_MODAL': false,
        //Vaibhav Singh : BT-106776 - 24-11-2023-  Added Modal - Start
        'BROKERAGE_MULTILEG': false,
        //Vaibhav Singh : BT-106776 - 24-11-2023-  Added Modal -End
        // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start
        'SIP_ORDER_STATUS_MODAL': false,
        // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End

        //user profile
        'USER_PROFILE_MODAL': false,
        'GUEST_USER_PROFILE_MODAL': false,
        'PROFILE_CONFIRMATION_MODAL': false,
        'PROFILE_SETTINGS_MODAL': false,
        'DELETE_PROFILE_CONFIRMATION_MODAL': false,
        'PROFILE_WEB_CAM_MODAL': false,
        'USER_DELETE_SUCCESS_MODAL': false,
        "USER_LOG_OUT_CONFIRMATION_MODAL": false,
        "CLOSE_ACCOUNT_MODAL": false,

        // Help
        'USAGE_GUIDE': false,
        'PRIVACY_POLICY': false,
        'KEYBOARD_SHORTCUTS': false,
        'CONTACT_US': false,
        'WALKTHROUGH': false,
        'DELETE_ALERT_SUCCESS_MODAL': false,
        'NEWS_DETAILS': false,
        'HOT_PURSUIT_DATA': false,
        'EVENTS_DETAILS': false,
        'RECOMMENDATION_FILTER_MODAL': false,
        'RECOMMENDATION_FOLLOW_UP_MODAL': false,
        'RECOMMENDATION_CART_MODAL': false,
        'CUSTOMISE_CART_ALERT_MODAL': false,
        'BASKET_RECO_FOLLOWUP_ALERT_MODAL': false,
        'BASKET_RECO_HOLDING_ALERT_MODAL': false,
        'ADD_LEG_MODAL': false,

        //login
        'FORGOT_MPIN_PASSWORD': false,
        'SET_ALERT_MODAL': false,

        //netposition
        "POSITION_SUMMARY": false,
        "CONVERT_POSITION": false,
        "POSITION_REPORT": false,
        'MODIFY_SQUARE_OFF_MODAL': false,
        'FILTER_ORDER_POSITION_MODAL': false,

        //inAppIFrameModal
        'IN_APP_IFRAME': false,

        //AddEndumAndNoticeReject
        'ADD_END_DUM_NOTICE': false,// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices

        //hamburger
        'SSO_LINK_MODAL': false,
        'MARKET_STATUS': false,  //Hari k:14-04-2025-market status
        //Manage Columns
        'MANAGE_COLUMNS_MODAL_STATUS': false,

        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
        //Settings
        'RESET_FONT_COLOR_CONFIRMATION_MODAL': false,
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

        //EVENTS - CORPORATE ACTIONS
        'CORPORATE_ACTIONS_DETAILS': false,
        //Ameersha N - 20-11-2023 - BT-95888 - Breeze- Create Watchlist - Start
        "WATCHLIST_SCRIP_STATUS": false,
        //Ameersha N - 20-11-2023 - BT-95888 - Breeze- Create Watchlist - End
        // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start
        'REMOVE_SCRIP_STATUS_MODAL': false,
        // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End

        'GUEST_USER_RESTRICTION_MODAL': false,//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges
        // Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - Start
        "EDIS_PERMISSION_MODAL_SINGLE_ORDER": false,
        "EDIS_PERMISSION_MODAL_PORTFOLIO": false,
        "EDIS_PERMISSION_MODAL_ORDER_CART": false,
        "EDIS_PERMISSION_MODAL_CONVERT_POSITION": false,
        // Ajitesh : 07/12/2023: BT-109135: Breeze eDIS implementation - End
        "PORTFOLIO_DONT_MISS_FILTERS": false,//Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss
        // Ajitesh : 16/02/2024: BT-109380 Contact Us - Start
        "VIEW_BRANCHES_MODAL": false,
        // Ajitesh : 16/02/2024: BT-109380 Contact Us - End
        //Ameerssha N : 18-07-2024 -- Devtools Warning model
        "DEV_TOOLS_MODAL": false,
        //Ameerssha N : 18-07-2024 -- Devtools Warning model
        // Ajitesh 07-08-2024 -- Disable TOTP from Settings modal
        "USER_DISABLE_TOTP_CONFIRMATION_MODAL": false,
        // Ajitesh 07-08-2024 -- Disable TOTP from Settings modal
        // AJitesh 12-09-2024 Benchmark performance info modal starts
        "BENCHMARK_PERFORMANCE_INFO_MODAL": false,
        // AJitesh 12-09-2024 Benchmark performance info modal ends
        // LTP Price band validation error modal
        "LTP_PRICE_BAND_VALIDATION_ERROR_MODAL": false,
        /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - Start */
        "SEGMENT_WISE_VERSION": false,
        /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - End */
        'MEMBERSHIP_DETAILS_MODAL': false,
        'AUTO_LOCK_MODAL': false,
        'MODERN_ALGO_MODAL': false,//Azeem K : 19-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo
        "BSE_PRE_TRADE_WARNING_MODAL": false
    },
    modalData: {}
};

const modalsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case HANDLE_MODALS: {
            return {
                ...state,
                modals: { ...actions.payload },
            };
        }
        case HANDLE_MODALS_DATA: {
            return {

                ...state,
                modalData: { ...actions.payload }
            };
        }

        default:
            return state;
    }

};
export default modalsReducer;